(function () {
    document.addEventListener("DOMContentLoaded", function () {


        initSection({
            holderId: "announcement-bar-holder",
            sectionName: "custom-announcement-bar",
            containerId: "announcement-bar-container",
        });

        if(window.location.pathname === "/") {
            initSection({
                holderId: "uhb-holder",
                sectionName: "under-hero-benefits",
                containerId: "under-hero-benefits-container",
            });
        }

        if (window.location.pathname.includes("/products/")) {
      
            initSection({
                holderId: "product-page-points-holder",
                sectionName: "product-page-points",
                containerId: "product-page-points-container",
            });

            initSection({
                holderId: "product-fit-gauge-holder",
                sectionName: "product-fit-gauge",
                containerId: "product-fit-gauge-container"
            });

            initSection({
                holderId: "product-page-shipping-holder",
                sectionName: "product-page-shipping",
                containerId: "product-page-shipping-container"
            });

            initSection({
                holderId: "tp-product-review-holder",
                sectionName: "tp-product-review",
                containerId: "tp-product-review-container"
            });

             initSection({
                holderId: "tiered-holder",
                sectionName: "tiered-discount-block",
                containerId: "tiered-discount-block-container"
            });

            initSection({
                holderId: "stock-holder",
                sectionName: "stock-count",
                containerId: "stock-count-container"
            });

            initSection({
              holderId: "ugc-reviews-slider-holder",
              sectionName: "ugc-reviews-slider",
              containerId: "ugc-reviews-slider-container",
              afterInject: initUGCReviewsSlider
            });

            initSection({
              holderId: "bundle-deals-banner-holder",
              sectionName: "bundle-deals-banner",
              containerId: "bundle-deals-banner-container"
            });

            initSection({
              holderId: "product-trust-icons-holder",
              sectionName: "product-trust-icons",
              containerId: "product-trust-icons-container"
            });


            // initSection({
            //     holderId: "product-bundle-savings-holder",
            //     sectionName: "product-bundle-savings",
            //     containerId: "product-bundle-savings-container"
            // });
        }

        if (window.location.pathname.includes("/cart")) {
            initSection({
                holderId: "cart-page-points-holder",
                sectionName: "cart-page-points",
                containerId: "cart-page-points-container"
            });
            initSection({
                holderId: "cart-reserved-holder",
                sectionName: "cart-reserved-timer",
                containerId: "cart-reserved-container",
                afterInject: initCartReservedTimer
            });
        }
    });

    /* -------------------------------------------
       GENERIC LOADER
    --------------------------------------------*/

     function initSection({
        holderId,
        sectionName,
        containerId,
        afterInject
    }) {
        let loaded = false;

        function checkInitValue() {
            const initValue = sessionStorage.getItem("initValue");

            if ((initValue === "111D" || initValue === "110wacD") && !loaded) {
                loaded = true;

                fetch(window.location.pathname + "?sections=" + sectionName)
                    .then((res) => res.json())
                    .then((data) => {
                        if (!data[sectionName]) return;

                        const holder = document.getElementById(holderId);
                        if (!holder) return;

                        holder.innerHTML = data[sectionName];

                        const block = document.getElementById(containerId);

                        console.log("reached block")
                        console.log("block")

                        if (block) block.style.display = "block";

                        if (typeof afterInject === "function") {
                            afterInject();
                        }
                    });
            } else if (initValue === null) {
                setTimeout(checkInitValue, 100);
            }
        }

        checkInitValue();
    }
})();

function watchDOM(callback) {
    const observer = new MutationObserver(function () {
        callback();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
}

let cartTimerInterval;

function initCartReservedTimer() {
    if (cartTimerInterval) clearInterval(cartTimerInterval);

    const container = document.getElementById("cart-reserved-container");
    const timerEl = document.getElementById("cart-reserved-timer");

    if (!container || !timerEl) return;

    const minutes = parseInt(container.dataset.minutes || "9", 10);
    let countdown = minutes * 60;

    function updateTimer() {
        const m = Math.floor(countdown / 60);
        const s = countdown % 60;

        timerEl.textContent = `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;

        if (countdown > 0) {
            countdown--;
        } else {
            clearInterval(cartTimerInterval);
            container.style.display = "none";
        }
    }

    updateTimer();
    cartTimerInterval = setInterval(updateTimer, 1000);
}

function initUGCReviewsSlider() {

  const slider = document.querySelector('.ugc-reviews-swiper');

  if (!slider) return;

  const jsonEl = document.getElementById('ugc-reviews-json');

  if (!jsonEl) return;

  let reviews = [];

  try {

    reviews = JSON.parse(
  jsonEl.innerHTML.trim()
);

    // reviews = JSON.parse(
    //   jsonEl.textContent
    // );

  } catch (e) {

    console.error('Invalid reviews JSON', e);

    return;
  }

  const wrapper = document.getElementById('ugc-reviews-wrapper');

  if (!wrapper) return;

  wrapper.innerHTML = '';

  reviews.forEach((review) => {

    const slide = document.createElement('div');

    slide.className = 'swiper-slide';

    slide.innerHTML = `
<div class="ugc-review-card">
   <img
      src="${review.image}"
      alt="${review.name}"
      loading="lazy"
      class="ugc-review-image"
      >

  <div class="ugc-card-content">
   <div class="ugc-review-card__text">
      ${review.text}
   </div>
   <div class="ugc-review-card__footer">
      <div class="ugc-review-rating">
        <div class="ugc-review-stars">
          <span>★</span>
          <span>★</span>
          <span>★</span>
          <span>★</span>
          <span>★</span>
        </div>
         <div class="ugc-review-verified">
            Verified
         </div>
      </div>
      <div class="ugc-review-name">
         ${review.name}
      </div>
   </div>
  </div>

</div>
    `;

    wrapper.appendChild(slide);
  });

  new Swiper('.ugc-reviews-swiper', {
    loop: true,
    speed: 600,
    spaceBetween: 24,
    grabCursor: true,

    navigation: {
      nextEl: '.ugc-reviews-next',
      prevEl: '.ugc-reviews-prev'
    },

    breakpoints: {
      0: {
         slidesPerView: 1.25,
         centeredSlides: false
      },

      768: {
        slidesPerView: 2
      },

      1024: {
        slidesPerView: 4
      }
    }
  });
}